import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
    username: string;
    // puedes agregar más propiedades si el backend las devuelve
}

interface LoginState {
token: string | null;
user: User | null;
isAuthenticated: boolean;
error: string | null;
}

const initialState: LoginState = {
token: null,
user: null,
isAuthenticated: false,
error: null,
};

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        loginSuccess(
          state: LoginState,
          action: PayloadAction<{ token: string; user: User }>
        ) {
          state.token = action.payload.token;
          state.user = action.payload.user;
          state.isAuthenticated = true;
          state.error = null;
        },
        loginError(state: LoginState, action: PayloadAction<string>) {
          state.token = null;
          state.user = null;
          state.isAuthenticated = false;
          state.error = action.payload;
        },
        logoutSuccess(state: LoginState) {
          state.token = null;
          state.user = null;
          state.isAuthenticated = false;
          state.error = null;
        },
      },
});

export const { loginSuccess, loginError, logoutSuccess } = loginSlice.actions;
export default loginSlice.reducer;
